require('./style.mn.js');
const React = require('react');
const body = document.body;
body.className = require('mn-utils/browser/detection')(
    require('mn-utils/get')(window, 'navigator.userAgent'));

const Space = require('./Space');

function App() {
  return (
    <div
      className="h100vh ov bg0 cD ff_Roboto,Helvetica,Arial,sans-serif f16
        fw4"
    >
      <Space className="abs s bg0" />
      <div
        className="rlv sq ov ovyA tl tc@m3 mb30>p
          (m|mb30|f26|fw6)>h1 (m|mb30|f20|fw6)>h2"
      >
        <div className="hmin w tbl pv30>1 pt15@m4>1">
          <div>
            <div className="mhA wmax992 ph30 ph15@m4">
              <div className="cfx mh-15 (lt|w1/2|w@m3|ph15)>1">
                <div>
                  <div className="w300 w200@m4 w@m5 mhA@m3">
                    <div className="ratio (wmax|dB)>img r ov">
                      <div>
                        <img src={require('./amirka.jpg?width=600')}/>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pt50 pt30@m3">
                  <h1>Amir Absalyamov</h1>
                  <p>Friends, the site is under construction.</p>
                  <p>You can contact me on Telegram:<br/>
                    <a
                      className="ttN olN tdU dn o70:h cCT f20"
                      href="https://t.me/mr_amirka"
                    >https://t.me/mr_amirka</a>
                  </p>
                  <p>Thank You for Your interest!</p>
                </div>
              </div>
              <div className="mt50 mt15@m3">
                <h2>Donate</h2>
                <div>
                  <div
                    className="cfx mh-5 (mb20|ph5|w1/2|w@m2|lt)>1 tl
                      break"
                  >
                    <div>
                      <div className="f12">Bitcoin</div>
                      <div>19zYNKWvQ4y6YK2sMWKcuFUxpgMjLDDcy2</div>
                    </div>
                    <div>
                      <div className="f12">Ethereum (ERC20)</div>
                      <div>0xab0f34d6c159f9c4f82f4d4cd8b49cff89dfcec8</div>
                    </div>
                    <div>
                      <div className="f12">Tron (TRC20)</div>
                      <div>TP1tDT75egtVra3FBrRRKxVnM7miYB3Fou</div>
                    </div>
                    <div>
                      <div className="f12">BSC (BEP20)</div>
                      <div>0xab0f34d6c159f9c4f82f4d4cd8b49cff89dfcec8</div>
                    </div>
                    <div>
                      <div className="f12">Solana</div>
                      <div>BdDpN57WYkSrF5JUXroP2cBJ4ajGPDbheFiQAjMZTqYj</div>
                    </div>
                    <div>
                      <div className="f12">RVN</div>
                      <div>RKkRgNTwESxrjck73giMSWuUtCoEZgwqPa</div>
                    </div>
                    <div>
                      <div className="f12">CTXC</div>
                      <div>0xab0f34d6c159f9c4f82f4d4cd8b49cff89dfcec8</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

require('react-dom').render(<App/>, document.getElementById('app'));

const attachEvent = require('mn-utils/attachEvent');
const play = require('mn-utils/withReDelay')(() => {
  audio.play();
}, 500);

const sounds = [
  require('./0.mp3'),
];

const audio = new Audio();
const length = sounds.length;
let index = 0;
audio.autoplay = true;
audio.src = sounds[index];

attachEvent(audio, 'ended', () => {
  index = (index + 1) % length;
  audio.src = sounds[index];
});

function touchstart() {
  if (audio.paused) {
    play();
    audio.volume = 1;
    return;
  }
  _cancel();
}
play();
const _cancel = attachEvent(body, 'click', touchstart, false);
